type CONSTANTSTYPE = Record<string, string>;

export const CONSTANTS: CONSTANTSTYPE = {
    SERVER_API_URL: `${window?.location?.protocol ?? 'http:'}//${window?.location?.hostname ?? 'localhost'}:${window?.location?.port ?? '8902'}/directory-manager`,
    USERNAME: '',
    ACCESS_TOKEN: '',
    REFRESH_TOKEN: '',
}